import { Validators } from '@angular/forms';
export class InvestmentIncomeDetailsModel {
  investmentList = {
    value: [],
    validation: Validators.compose([]),
  };
}

export class IndividualInvestmentIncomeModel {
  useAsSecurity = {
    value: false,
    validation: Validators.compose([])
  };
  refinancing = {
    value: false,
    validation: Validators.compose([])
  };
  isNewInvestment = {
    value: false,
    validation: Validators.compose([])
  };
  invLoanIntAddback = {
    value: null,
    validation: Validators.compose([])
  };
  interestOnly = {
    value: false,
    validation: Validators.compose([])
  };
  address = {
    value: null,
    validation: Validators.compose([])
  };
  securityAddress = {
    value: null,
    validation: Validators.compose([])
  };
  propertyType = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  assetValue = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };
  investmentLoanBalance = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  frequencyType = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  rent = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };
  monthlyRepayments = {
    value: '',
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };
  creditProvider = {
    value: null,
    validation: Validators.compose([])
  };
  isHighDensity = {
    value: false,
    validation: Validators.compose([])
  };
  // AddressModel = AddressModel;
  parties = [];
  link = {
    value: null,
    validation: Validators.compose([])
  };
}
